var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAddToMyStats = function SvgAddToMyStats(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 5h2v20h-2zm5 5h-2v15h2zm-9 1H8v14h2zm-3 7H5v7h2zm15 1h-2v6h2zm1 3h2v3h-2zm-12-8h2v11h-2z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 5h2v20h-2zm5 5h-2v15h2zm-9 1H8v14h2zm-3 7H5v7h2zm15 1h-2v6h2zm1 3h2v3h-2zm-12-8h2v11h-2z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 3h9v3H0z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 3h9v3H0z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3 9V0h3v9z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3 9V0h3v9z"
  })));
};
export default SvgAddToMyStats;